import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-551e6077"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "request-section"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Request summary", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Automation type:", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Manual")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason for manual review:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "request-section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Ticket ID", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Original submission: ")
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Follow-ups: ")
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "request-section" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Request summary", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Automation type:", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Full")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Automation type:", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Partial")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Approval status:", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "** No quote generated **", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Request type:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = { key: 4 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason for manual review:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { key: 5 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reason for cancellation:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { key: 6 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Other cancel explanation:", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "other-cancel-section" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Cancellation reason:")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Cancellation effective date:")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = {
  key: 0,
  class: "error-section"
}
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note-section" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Uh oh! Approving this request didn't work. Please manually close out this ticket.")
], -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { key: 2 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "note-section" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "NOTE:", -1))
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" This policy is already pending cancellation. Approving this request will allow the broker to withdraw the existing cancellation transaction and bind the new cancellation. ")
const _hoisted_70 = [
  _hoisted_68,
  _hoisted_69
]
const _hoisted_71 = {
  key: 0,
  class: "error-section"
}
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["disabled"]
const _hoisted_74 = {
  key: 1,
  class: "request-section"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Broker confirmation", -1))
const _hoisted_76 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Change confirmation status:", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Magic link status:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = {
  key: 2,
  class: "note-section"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We were unable to generate a quote for this request due to the issue(s) listed above. Please address these issues and retry quote to proceed with this request. ", -1))
const _hoisted_84 = [
  _hoisted_83
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.requestData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.manual)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.helpCenterManualReviewReason), 1),
              _hoisted_10
            ]))
          : _createCommentVNode("", true),
        (!_ctx.manual)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _hoisted_16,
                    _createElementVNode("span", {
                      innerHTML: _ctx.serializeOriginalTicket()
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_18,
                    _createElementVNode("span", { innerHTML: _ctx.serializeFollowUpTickets }, null, 8, _hoisted_19)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                (_ctx.fullyAutomated)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _hoisted_28))
                  : _createCommentVNode("", true),
                (_ctx.partiallyAutomated)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_33))
                  : _createCommentVNode("", true),
                (_ctx.actionable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                      _hoisted_35,
                      _createTextVNode(" " + _toDisplayString(_ctx.approvalStatus) + " ", 1),
                      (_ctx.reviewGiven)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                            _createElementVNode("li", null, "Timestamp: " + _toDisplayString(_ctx.reviewTimestamp), 1),
                            _createElementVNode("li", null, "Reviewer: " + _toDisplayString(_ctx.reviewer), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.actionable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _hoisted_40))
                  : _createCommentVNode("", true),
                _hoisted_41,
                _createTextVNode(" " + _toDisplayString(_ctx.requestData.requestInfo.inquiryType), 1),
                _hoisted_42,
                (!_ctx.fullyAutomated)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                      _hoisted_44,
                      _createTextVNode(" " + _toDisplayString(_ctx.helpCenterManualReviewReason), 1),
                      _hoisted_45
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.reasonedCancellation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                      _hoisted_47,
                      _createTextVNode(" " + _toDisplayString(_ctx.cancelReason), 1),
                      _hoisted_48
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.otherCancellation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                      _hoisted_50,
                      _createTextVNode(" " + _toDisplayString(_ctx.requestData.requestInfo.otherCancelExplanation), 1),
                      _hoisted_51
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ((_ctx.otherCancellation || _ctx.pendingCancellation) && _ctx.actionable && _ctx.pendingReview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _hoisted_55,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.otherCancelReason = $event)),
                        class: "reason-selector"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelReasons, (reason) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: reason,
                            value: reason
                          }, _toDisplayString(_ctx.CANCEL_REASON_LABELS[reason]), 9, _hoisted_56))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.otherCancelReason]
                      ]),
                      _hoisted_57,
                      _hoisted_58,
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.otherCancelEffectiveDate = $event)),
                        class: "effective-date-selector"
                      }, null, 512), [
                        [_vModelText, _ctx.otherCancelEffectiveDate]
                      ]),
                      (_ctx.cancelNotTaken)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, " Note the cancellation effective date will automatically update to the policy effective date if not taken. "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.resolutionError && _ctx.partiallyAutomated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_62))
                : _createCommentVNode("", true),
              (!_ctx.resolutionError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    (_ctx.actionable && _ctx.pendingReview)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            (!_ctx.pendingCancellation)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_66, "Approving this request will trigger an email to the requester, at which point no further BSA action is required."))
                              : _createCommentVNode("", true),
                            (_ctx.pendingCancellation)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_67, _hoisted_70))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.approveDisabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, " Please select a cancellation reason and valid effective date before approving. "))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "approve-button",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resolveRequest('approve'))),
                            disabled: _ctx.resolving || _ctx.approveDisabled
                          }, " Approve ", 8, _hoisted_72),
                          _createElementVNode("button", {
                            class: "reject-button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resolveRequest('reject'))),
                            disabled: _ctx.resolving
                          }, " Reject ", 8, _hoisted_73)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.actionable && !_ctx.pendingReview && _ctx.isApproved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _hoisted_75,
                          _hoisted_76,
                          _hoisted_77,
                          _hoisted_78,
                          _createTextVNode(" " + _toDisplayString(_ctx.requestConfirmation), 1),
                          _hoisted_79,
                          _hoisted_80,
                          _createTextVNode(" " + _toDisplayString(_ctx.requestExpiration), 1),
                          _hoisted_81
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.actionable && !_ctx.fullyAutomated)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}